import Vue from 'vue'

const $vm = new Vue()
const Loading = {
  timer: null,
  timers: [],
  show() {
    this.timer = setTimeout(() => {
      $vm.$Spin.show({
        render: (h) => {
          return h('div', [
            h('Icon', {
              'class': 'f-spin-icon-load',
              props: {
                type: 'ios-loading',
                size: 18
              }
            }),
            h('div', '加载中...')
          ])
        }
      })
    }, 500)
    this.timers.push(this.timer)
  },
  hide() {
    $vm.$Spin.hide()
    clearTimeout(this.timers.pop())
  }
}
Vue.prototype.$loading = Loading
